const CC = require('CC');
const Cells = require('./Cells');
const Backbone = require('backbone');
export { Cells };

export class ColumnBuilder {
    static IGNORE = 'ignore';

    constructor() {
        this.columnDefinitions = [];
    }

    addColumn(type, options) {
        this.columnDefinitions.push({ type, options });
        return this;
    }

    /**
     * Supports legacy action otions
     * @param {Ojbect} options
     * @returns {ColumnBuilder}
     */
    actions(options = {}) {
        return this.addColumn(Cells.ActionCell, { title: 'Actions', ...options });
    }

    /**
     *
     * @param {ActionBuilder} actionBuilder
     * @returns {Array} of actions
     */
    actionBuilder(actionBuilder) {
        return this.actions({
            viewOptionsFn: (data, type, row, meta, model) => {
                return {
                    model: model,
                    data: actionBuilder.build(model)
                };
            }
        });
    }

    /**
     * A column that is dynamiclly set based on currentState option (property or function)
     * @param {DataGrid.Cells} type
     * @param {Object} options
     * @returns {ColumnBuilder} reference
     *
     * @example
     * states: {
     *    panos: {
     *        data: 'panoramaIds',
     *        title: 'Panorama IDs'
     *     },
     *     uniques: {
     *        data: 'uniques',
     *        title: 'Active Uniques'
     *     }
     * },
     * width: '102px',
     * currentState: this.showPanoIdCountStats ? 'panos' : 'uniques'
     */
    contextualColumn(type, options = {}) {
        const state = CC.utils.getResult(options, 'currentState', {});
        if (state === ColumnBuilder.IGNORE) {
            return this;
        }
        const stateOptions = options.states?.[state] || {};
        const finalType = type || stateOptions.type;

        if (finalType == null) {
            throw new Error('Column type must be specified');
        }

        return this.addColumn(finalType, {
            ...options,
            ...stateOptions
        });
    }

    currency(data, title, options = {}) {
        return this.addColumn(Cells.CurrencyCell, { data, title, ...options });
    }

    date(data, title, options = {}) {
        return this.addColumn(Cells.DateCell, { data, title, ...options });
    }

    enum(data, title, options = {}) {
        return this.addColumn(Cells.EnumCell, { data, title, ...options });
    }

    expand(options = {}) {
        return this.addColumn(Cells.ExpandCell, { ...options });
    }

    exportOnly(data, title, options = {}) {
        return this.addColumn(Cells.ExportOnlyCell, { data, title, ...options });
    }

    icon(data, title, options = {}) {
        return this.addColumn(Cells.IconCell, { data, title, ...options });
    }

    id(data, title, options = {}) {
        return this.addColumn(Cells.IdCell, { data, title, ...options });
    }

    link(data, title, options = {}) {
        return this.addColumn(Cells.LinkCell, { data, title, ...options });
    }

    stat(data, title, options = {}) {
        return this.addColumn(Cells.StatCell, { data, title, ...options });
    }

    text(data, title, options = {}) {
        return this.addColumn(Cells.TextCell, { data, title, ...options });
    }

    view(data, title, options = {}) {
        return this.addColumn(Cells.ViewCell, { data, title, ...options });
    }

    buildColumns() {
        const columns = new Backbone.Collection(null, {
            comparator: false // Disable sorting
        });

        const models = this.columnDefinitions.map(({ type, options }) => type(options));

        columns.add(models);
        return columns.toJSON();
    }
}
